/**
 * AuthCallback Component
 * 
 * Handles OAuth callback (placeholder for future OAuth integration).
 * Currently redirects to login page.
 */

import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTheme } from '../context/ThemeContext';

export default function AuthCallback() {
  const [status] = useState('Redirecting to login...');
  const { isDark } = useTheme();
  const navigate = useNavigate();

  useEffect(() => {
    // Redirect to login page
    // This is a placeholder for future OAuth integration
    setTimeout(() => {
      navigate('/login', { replace: true });
    }, 1500);
  }, [navigate]);

  return (
    <div className={`min-h-screen flex items-center justify-center ${isDark ? 'bg-gradient-to-br from-gray-900 via-slate-900 to-gray-900' : 'bg-gradient-to-br from-slate-50 via-blue-50 to-slate-100'}`}>
      <div className={`backdrop-blur-xl rounded-2xl border shadow-2xl p-8 max-w-md w-full mx-6 ${isDark ? 'bg-gray-800/50 border-gray-700/50' : 'bg-white/80 border-gray-200'}`}>
        <div className="flex justify-center mb-4">
          <svg className="animate-spin h-16 w-16 text-blue-500" viewBox="0 0 24 24">
            <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" fill="none"/>
            <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"/>
          </svg>
        </div>
        <h2 className={`text-xl font-semibold mb-4 text-center ${isDark ? 'text-white' : 'text-slate-900'}`}>
          {status}
        </h2>
        <p className={`text-center text-sm ${isDark ? 'text-gray-500' : 'text-gray-400'}`}>
          Please wait while we complete your login...
        </p>
      </div>
    </div>
  );
}
